export default __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/google_podcasts-884bc82e3ab864438cacc0dbb6c310a7.svg";